import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const enumsSlice = createSlice({
  name: 'enumsData',
  initialState: {
    enums: {} as any,
  },
  reducers: {
    setEnums: (state, action) => {
      state.enums = action.payload;
    },
  },
});

export const { setEnums } = enumsSlice.actions;
export const getEnumsData = (state: RootState) => state.enumsSlice;
export const getAppointmentStatus = (state: RootState) => {
  const status: any = {};

  state.enumsSlice.enums.appointment_status_enums.forEach((item: any) => {
    switch (item.value) {
      case '0':
        status.NEW = item.value;
        break;
      case '1':
        status.PENDING = item.value;
        break;
      case '2':
        status.CONFIRMED = item.value;
        break;
      case '3':
        status.CANCELLED = item.value;
        break;
      case '4':
        status.NEXT = item.value;
        break;
      case '5':
        status.PREVIOUS = item.value;
        break;
      default:
        break;
    }
  });

  return status;
};

export const getQuestionBasicTypes = (state: RootState) => {
  const type: any = {};

  state.enumsSlice.enums.basic_question_enums?.forEach((item: any) => {
    switch (item.value) {
      case '0':
        type.NAME = item.value;
        break;
      case '1':
        type.PHONE = item.value;
        break;
      case '2':
        type.EMAIL = item.value;
        break;
      default:
        break;
    }
  });

  return type;
};

export const getSurveyQuestionTypes = (state: RootState) => {
  const type: any = {};

  state.enumsSlice.enums.survey_question_types_enums?.forEach((item: any) => {
    switch (item.value) {
      case '0':
        type.SMALL_TEXT = item.value;
        break;
      case '1':
        type.NUMBER = item.value;
        break;
      case '2':
        type.CHOOSE = item.value;
        break;
      case '3':
        type.MULTIPLE_CHOICES = item.value;
        break;
      case '4':
        type.DATE = item.value;
        break;
      case '5':
        type.BIG_TEXT = item.value;
        break;
      case '6':
        type.DROPDOWN = item.value;
        break;
      case '7':
        type.PHONE = item.value;
        break;
      default:
        break;
    }
  });

  return type;
};

export default enumsSlice.reducer;
